import { EMERALD_CITY_PRODUCT } from "@constants/images";
const TopBanner = () => {
  return (
    <div className="topBanner-emeraldCity">
      <img
        src={EMERALD_CITY_PRODUCT.LOGO}
        alt="gangstabet logo"
        className="wow animate__animated animate__fadeIn"
      />
    </div>
  );
};

export default TopBanner;
